import styled from 'styled-components';

export const StyledSources = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  width: 100%;
  height: 100%;
  padding: 0px 20px;
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Sources/Sources.styles.js